import React from 'react';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import { BottomNavigationActionProps } from '@material-ui/core/BottomNavigationAction/BottomNavigationAction';

const BottomNavAction = (props: BottomNavigationActionProps) => (
  <BottomNavigationAction
    classes={{ selected: 'selected', label: 'label', root: 'root', wrapper: 'wrapper' }}
    {...props}
  />
);

export default BottomNavAction;
